import { render, staticRenderFns } from "./ProfileCertificatesEducationsView.vue?vue&type=template&id=fb90e580"
import script from "./ProfileCertificatesEducationsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileCertificatesEducationsView.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports